import { createStyles } from '@mantine/core';
var useStyles = createStyles(function (theme, _ref) {
  var ringSize = _ref.ringSize;
  return {
    root: {
      color: theme.colorScheme === "dark" ? theme.white : theme.black,
      fontSize: "18px",
      fontWeight: 400
    },
    info: {
      p: {
        fontSize: "18px"
      }
    },
    systemName: {
      margin: 0,
      textTransform: "uppercase",
      fontSize: "26px",
      fontWeight: 500
    },
    noSelection: {
      fontWeight: 400
    },
    subHeader: {
      margin: 0,
      fontSize: "16px",
      fontWeight: 400,
      color: "#B0B0B0"
    },
    description: {
      marginTop: "0.25rem"
    },
    contestedStatus: {
      margin: 0,
      "& b": {
        fontWeight: 400
      }
    },
    advantageHeader: {
      marginBottom: "-10px",
      fontWeight: 400,
      fontSize: "16px"
    },
    advantageContainer: {
      width: "100%",
      height: "100px",
      position: "relative"
    },
    attackerAdvantage: {
      position: "absolute",
      left: 0,
      top: "".concat(ringSize * 0.3, "px"),
      height: "".concat(ringSize * 0.1, "px"),
      right: "".concat(ringSize * 0.85, "px")
    },
    defenderAdvantage: {
      position: "absolute",
      left: 0,
      top: "".concat(ringSize * 0.6, "px"),
      height: "".concat(ringSize * 0.1, "px"),
      right: "".concat(ringSize * 0.85, "px")
    },
    resolvedAdvantage: {
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      svg: {
        circle: {
          transition: "all 300ms ease-in-out"
        }
      }
    }
  };
});
export { useStyles as default };